"use strict";
console.log("connect with accolade-new-cost");
function _locationToEmail() {
  // TODO: Create an input element that store the location2E
  const pInfo = $(".personal-info");
  const isFine = pInfo !== undefined && pInfo !== null;

  // Clear the location2E input
  $("#location2E").remove();

  if (isFine) {
    const loc2es = []
    accolade.locations.forEach((e)=>{ loc2es.push(e.name)  })
    // Create an input element that store the location2E
    const location2EInput = document.createElement("input");
    location2EInput.setAttribute("id", "location2E");
    location2EInput.setAttribute("type", "hidden");
    location2EInput.setAttribute("name", "selected-regions");
    location2EInput.setAttribute("value", loc2es);
    pInfo.prepend(location2EInput);
  }
}

function sktotalprice() {
  document.querySelector("#total-price").innerHTML = "";

  var sktotal = [];

  accolade.locations.forEach((e) => {
    sktotal.push(e.firstClassFee * 1 + e.extraClassFee * (acctrade.length - 1));
  });

  console.log(sktotal);

  var newsktotal = sktotal.reduce((a, b) => a + b, 0);

  console.log("Tracking Total Price: ", newsktotal);

  document.querySelector("#total-price").innerHTML =
    _formatMoneyWithIntl(newsktotal);
}

// variable to store our intervalID
let nIntervId;
var accmain = [];
var acctrade = [];
let lastAlert = null;

function accskcbd() {
  for (let i = 0; i < accolade.locations.length; i++) {
    let tre = document.createElement("tr");
    tre.innerHTML =
      `
        <td class="table-cou skpt-xs skpb-xs">
        <div class="table-cou-inner">
            <span class="cou-imgb">
                <img class="nc-img" src="` +
                accolade.locations[i]?.img +
      `">
            </span>
            <p>
                <span class="textgroup" style="display: flex;flex-direction: column;">
                    <span class="fs-h6 text-sub nc-title">` +
                    accolade.locations[i]?.name +
      `</span>
                    <span class="fs-12 text-main">
                        <span class="tt-upper nc-countrycode" >` +
                        accolade.locations[i]?.isoCode +
      `</span>
                    </span>
                </span>
            </p>
        </div>
        </td>  
        <td class="table-tc skpt-xs skpb-xs">
        <div class="table-tc-inner fs-16 flex-column d-flex">
            <div class="d-flex justify-content-between align-items-center order-1">
                <span>POA Fee</span>
                <span class="nc-poafee">` +
      _formatMoneyWithIntl(accolade.locations[i]?.poaFee) +
      `</span>
            </div>
            <div class="d-flex justify-content-between align-items-center order-2">
                <span>Search Fee</span>
                <span class="nc-searchfee" >` +
      _formatMoneyWithIntl(accolade.locations[i]?.searchFee) +
      `</span>
            </div>
        </div>
        </td>
        `;

    document.querySelector(".new-cost #new-cost-id").appendChild(tre);
    console.log(tre);
    for (let t = 0; t < acctrade.length; t++) {
      let trade = document.createElement("div");
      trade.classList.add(
        "d-flex",
        "justify-content-between",
        "align-items-center",
        "trademark-container"
      );
      if (t === 0) {
        trade.innerHTML =
          `
                    <div class="trademarkList">
                    <p>` +
          acctrade[t]?.label +
          `</p>
                    <div>
                        <img class="delete-icon" src="https://cdn.shopify.com/s/files/1/0784/9836/5736/files/Delete.svg" alt="delete icon" data-id=` +
          acctrade[t]?.id +
          `>
                    </div>
                    </div>
                    <p class="fs-16 nc-firstfee">` +
          _formatMoneyWithIntl(accolade.locations[i]?.mockFirstClassFee) +
          `</p>      
                    `;
        document
          .querySelectorAll(".new-cost #new-cost-id .table-tc-inner")
          [i].appendChild(trade);
        console.log(trade);
      }
      if (t !== 0) {
        trade.innerHTML =
          `
            <div class="trademarkList">
              <p>` +
          acctrade[t]?.label +
          `</p>
              <div>
                  <img class="delete-icon" src="https://cdn.shopify.com/s/files/1/0784/9836/5736/files/Delete.svg" alt="delete icon" data-id=` +
          acctrade[t]?.id +
          `>
              </div>
            </div>

            <p class="fs-16 nc-firstfee">` +
          _formatMoneyWithIntl(accolade.locations[i]?.extraClassFee) +
          `</p>      
            `;
        document
          .querySelectorAll(".new-cost #new-cost-id .table-tc-inner")
          [i].appendChild(trade);
        console.log(trade);
      }
    }
  }

  sktotalprice();
}

function startfn() {
  // check if an interval has already been set up
  if (!nIntervId) {
    window.accmain = [];
    window.acctrade = [];
    window.accolade.locations = [];
    window.accolade.items = [];

    $(".new-cost #new-cost-id").empty();
    $(".cou-items").find("input[type=checkbox]").prop("checked", false);
    $(".cou-items").find("label").removeClass("checked");
    $(".cou-selected").empty();
 
    accolade.trademarks?.map((tm) => {
      //! If tm.label contains "-" then split it and get the second part
      if (tm.label.includes("-")) {
        // tm.label = tm.label.split("-")[1].trim(); 
        tm.label = tm.label.trim();
        accolade.quantity = accolade.trademarks.length;
      }

      accolade.quantity = accolade.trademarks.length;

      return tm.label;
    });

    _clearAllCartItems();

    nIntervId = setInterval(acclfn, 500);
  }
}

function acclfn() {
  if (accolade.trademarks.length !== 0) {
    for (let i = 0; i < accolade.trademarks.length; i++) {
      if (acctrade[i] !== accolade.trademarks[i]) {
        acctrade.splice(i, 0, accolade.trademarks[i]);
      }
    }
  }
  // if (accolade.locations.length !== 0) {
  //   for (let i = 0; i < accolade.locations.length; i++) {
  //     if (accmain[i] !== accolade.locations[i]) {
        
  //       accmain.splice(i, 0, accolade.locations[i]);
  //     }
  //   }
  // }
}

function stopfn() {
  clearInterval(nIntervId);
  // release our intervalID from the variable
  nIntervId = null;
  console.log(accmain);
  console.log(acctrade);
  accskcbd();
}

document.querySelectorAll(".cou-items input").forEach((e) => {
  e.onchange = () => {
    startfn();
    console.log("skcheckid" + e.id);
  };
});





document.querySelectorAll(".cou-selectbody .selectRegion").forEach((e) => {
  e.onclick = () => {
    startfn();
  };
});
document.querySelectorAll(".cou-searchg .cou-search").forEach((e) => {
  e.onclick = () => {
    startfn();
  };
});
document.querySelectorAll(".cou-searchg .selectbtn").forEach((e) => {
  e.onclick = () => {
    startfn(); 
  };
});

document.querySelectorAll("#step2 .btns>.btn:nth-child(2)").forEach((e) => {
  e.onclick = () => {
    stopfn();
    _locationToEmail();
    _sendHistoryToEmail();
    _classToEmail();
    _amountToEmail();

  };
});

// function addfadeitem(){
//   if(document.querySelector('#removefade2nd').innerHTML == ""){
//     var sharem = document.createElement('label')
//     sharem.classList.add('fs-h6', 'item', 'hide')
//     sharem.setAttribute('for', 'fade2')
//     sharem.innerHTML = '<input type="checkbox" name="fade2" id="fade2">'
//     document.querySelector('#removefade2nd').appendChild(sharem)
//   }
// }

function removeqty() {
  window.accolade.items.forEach((item, index) => {
    if (index % 2) {
      console.log(item, index);
      item.quantity = item.quantity - 1;
    }
  });
}

let inter;
function startdfn() {
  if (!inter) {
    inter = setInterval(firstfeechangerfn, 500);
  }
}

function firstfeechangerfn() {
  var tableRows = document.querySelectorAll("#new-cost-id tr");
  tableRows.forEach((row) => {
    var deleteIcons = row.querySelectorAll(".delete-icon");
    for (let d = 0; d < deleteIcons.length; d++) {
      deleteIcons[d].onclick = () => {
        if (deleteIcons.length !== 1) {
          // Implement with _showAlert
          const noty = new Noty({
            text: "Are you sure to remove this trademark from the list?",
            type: "alert",
            layout: "center",
            theme: "semanticui",
            modal: true,
            animation: {
              open: function (promise) {
                const n = this;
                n.barDom.style.visibility = "visible";
                $(n.barDom).fadeIn(300, function () {
                  promise(function (resolve) {
                    resolve();
                  });
                });
              },
              close: function (promise) {
                const n = this;
                $(n.barDom).fadeOut(300, function () {
                  $(n.barDom).remove();
                  promise(function (resolve) {
                    resolve();
                  });
                });
              },
            },
            buttons: [
              Noty.button("&#10005;", "btn btn-error close-btn", function () {
                // If the user clicks the "x" icon, do nothing (close the prompt)
                noty.close();
              }),

              Noty.button("Yes, remove.", "btn btn-success", function () {
                //! TODO: Remove the trademark from the list
                acctrade.splice(d, 1);
                $(".new-cost #new-cost-id").empty();

                accskcbd();
                removeqty();
                sktotalprice();

                // TODO: Have to remove the keywords from accolade.searchHistory
                let delete_icon_id = $(deleteIcons[d]).attr("data-id").trim();

                //* If the delete_icon_id doesn't included "_" then use it as normal
                if (!delete_icon_id.includes("_")) {
                  delete_icon_id = delete_icon_id;
                } else {
                  delete_icon_id = delete_icon_id.split("_")[0].trim();
                }

                accolade.searchHistory.map((sh) => {
                  const id = sh.id.split("_")[0].trim();

                  if (id === delete_icon_id) {
                    const index = accolade.searchHistory.indexOf(sh);

                    accolade.searchHistory[index].keywords = "";
                  }
                });

                _sendHistoryToEmail();
                _classToEmail();
                _amountToEmail();

                noty.close();
              }),

              Noty.button("Discard", "btn btn-error", function () {
                noty.close();
              }),
            ],
          }).show();
        } else {
          if (lastAlert) {
            lastAlert.close();
          }

          lastAlert = new Noty({
            type: "alert",
            layout: "center",
            theme: "semanticui",
            modal: true,
            text: "There should be at least one trademark item remaining!",
            timeout: 3000,
          }).show();
        }
      };
    }
  });
}

function stopdfn() {
  clearInterval(inter);
  inter = null;
}

document.querySelectorAll("#new-cost-id").forEach((e) => {
  e.onmouseenter = () => {
    startdfn();
  };
});

document.querySelectorAll("#new-cost-id").forEach((e) => {
  e.onmouseleave = () => {
    stopdfn();
  };
});

function _finalAddCartItems() {
  const url = window.Shopify.routes.root + "cart/add.js";

  const itemsProperties = window.accolade.items.map((item) => {
    const chooseTrademark = acctrade.map((tm) => tm.label).join("\n");
    const id = item.id;
    const quantity = item.quantity;

    return {
      id,
      quantity,
      properties: {
        "Choose Trademarks ": chooseTrademark,
      },
    };
  });

  const data = {
    items: itemsProperties,
    note:
      "User choose keywords: \n" +
      accolade.searchHistory
        .map((sh) => {
          const label = sh.label?.split("-")[1].trim().slice(0, 3);
          const keywords = sh?.keywords;

          if (keywords === "") return;

          return `${keywords}`;
        })
        .join("\n")
        .trim(),
    // note:
    //   "Ordered notes: " + accolade.trademarks.map((tm) => tm.label).join(",\n"),
  };

  $.ajax({
    url: url,
    type: "POST",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(data),
    success: function (data) {
      console.log("_finalAddCartItems: ", data);
    },
    error: function (data) {
      console.log("_finalAddCartItems: ", data);
    },
  });
}

function _clearAllCartItems() {
  const url = "/cart/clear.js";

  $.ajax({
    url: url,
    type: "POST",
    dataType: "json",
    success: function (data) {
      // _updateCartUI();
      console.log("Cleared the cart items");
    },
  });
}

$("#addItems").click(function (event) {
  $.ajax({
    url: window.Shopify.routes.root + "cart/clear.js",
    type: "POST",
    dataType: "json",
  }).done(function (data) {
    // TODO: Add the items to the cart
    _finalAddCartItems();
  });
});

$("#step3Submit").on("click", async function (event) {
  $("#addItems").click();

  const message =
    "Successfully submitted the form! Soon will redirect to the checkout page";

  const submitForm = $(".mainform-details");

  if ($(submitForm).length > 0) {
    event.preventDefault();

    const isRadioSelected =
      $("#word").prop("checked") ||
      $("#logo").prop("checked") ||
      $("#both").prop("checked");

    if (!isRadioSelected) {
      const noty = new Noty({
        text: "Please choose a trademark or logo type prior to checkout!",
        type: "info",
        layout: "center",
        theme: "semanticui",
        modal: true,
        animation: {
          open: function (promise) {
            const n = this;
            n.barDom.style.visibility = "visible";
            $(n.barDom).fadeIn(300, function () {
              promise(function (resolve) {
                resolve();
              });
            });
          },
          close: function (promise) {
            const n = this;
            $(n.barDom).fadeOut(300, function () {
              $(n.barDom).remove();
              promise(function (resolve) {
                resolve();
              });
            });
          },
        },
        buttons: [
          Noty.button("OK", "btn btn-success checkForm", function () {
            noty.close();
          }),
        ],
      });

      noty.show();
      return;
    }

 var captchaResponse = grecaptcha.getResponse();
if ($(submitForm)[0].checkValidity() && captchaResponse.length !== 0) {
      const formData = new FormData($(submitForm)[0]);
      const message =
        "Successfully submitted the form! Soon will redirect to the checkout page";

      $.ajax({
        url: submitForm.attr("action"),
        type: submitForm.attr("method"),
        data: formData,
        processData: false,
        contentType: false,
        success: function () {
          //! Show the alert before redirecting to the checkout page
          _showAlert(message, "info", 5000);
          window.location.href = "/checkout";
        },
        error: function () {
          $(this).text("Submitting...");
          //! Show the alert before redirecting to the checkout page
          _showAlert(message, "info", 5000);
          window.location.href = "/checkout";
        },
      });
    } else {
      const noty = new Noty({
        text: "Please provide your trademark information before proceeding to checkout and complete the 'I am not a robot' verification.",
        type: "info",
        layout: "center",
        theme: "semanticui",
        modal: true,
        animation: {
          open: function (promise) {
            const n = this;
            n.barDom.style.visibility = "visible";
            $(n.barDom).fadeIn(300, function () {
              promise(function (resolve) {
                resolve();
              });
            });
          },
          close: function (promise) {
            const n = this;
            $(n.barDom).fadeOut(300, function () {
              $(n.barDom).remove();
              promise(function (resolve) {
                resolve();
              });
            });
          },
        },
        buttons: [
          Noty.button("OK", "btn btn-success checkForm", function () {
            noty.close();
          }),
        ],
      });

      noty.show();
    }
  }
});

function _sendHistoryToEmail() {
  // TODO: Create an input element that store the searchHistory
  const personalInfo = $(".personal-info");
  const isFine = personalInfo !== undefined && personalInfo !== null;

  // Clear the searchHistory input
  $("#searchHistory").remove();

  if (isFine) {
    const searchHistories = accolade.searchHistory?.map(
      //* If has empty quote then remove it if still remaing etra comma then trim it
      ({ keywords }) =>
        JSON.stringify(keywords).replace(/\"/g, "").replace(/\,/g, "").trim()
    );
    // Create an input element that store the searchHistory
    const searchHistoryInput = document.createElement("input");
    searchHistoryInput.setAttribute("id", "searchHistory");
    searchHistoryInput.setAttribute("type", "hidden");
    searchHistoryInput.setAttribute("name", "search-history");
    searchHistoryInput.setAttribute("value", searchHistories);
    personalInfo.prepend(searchHistoryInput);
  }
}

function _classToEmail() {
  // TODO: Create an input element that store the class2E
  const pInfo = $(".personal-info");
  const isFine = pInfo !== undefined && pInfo !== null;

  // Clear the class2E input
  $("#class2E").remove();

  if (isFine) {
    const class2es = []
    acctrade.forEach((e)=>{ class2es.push(e.label)  })
    // Create an input element that store the class2E
    const class2EInput = document.createElement("input");
    class2EInput.setAttribute("id", "class2E");
    class2EInput.setAttribute("type", "hidden");
    class2EInput.setAttribute("name", "selected-classfications");
    class2EInput.setAttribute("value", class2es);
    pInfo.prepend(class2EInput);
  }
}
function _amountToEmail() {
  // TODO: Create an input element that store the amount2E
  const pInfo = $(".personal-info");
  const isFine = pInfo !== undefined && pInfo !== null;

  // Clear the amount2E input
  $("#amount2E").remove();

  if (isFine) {
    const amount2es = document.querySelector("#total-price").innerHTML
    // Create an input element that store the amount2E
    const amount2EInput = document.createElement("input");
    amount2EInput.setAttribute("id", "amount2E");
    amount2EInput.setAttribute("type", "hidden");
    amount2EInput.setAttribute("name", "total-amount");
    amount2EInput.setAttribute("value", amount2es);
    pInfo.prepend(amount2EInput);
  }
}

const _formatMoneyWithIntl = (amount) => {

  if(window.location.href.split("/")[3].split("-")[1] === "aud"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  }
  else if(window.location.href.split("/")[3].split("-")[1] === "nzd"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NZD",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  }  
  else if(window.location.href.split("/")[3].split("-")[1] === "cad"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  }  
  else if(window.location.href.split("/")[3].split("-")[1] === "eur"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  }  
  else if(window.location.href.split("/")[3].split("-")[1] === "gbp"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  } 
  else if(window.location.href.split("/")[3].split("-")[1] === "hk"){
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "HKD",
      minimumFractionDigits: 0,
    });
    return formatter.format(amount);
  }  
  else{
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "TWD",
      minimumFractionDigits: 0, 
    });
    return formatter.format(amount);
  }





};

function _formatLabel(text) {
  if (text.includes("-")) {
    text.split("-")[1].trim();
  }

  return text;
}

function _showAlert(message, type, timeout) {
  new Noty({
    text: message,
    type: type,
    layout: "center",
    theme: "semanticui",
    timeout: timeout,
    animation: {
      open: function (promise) {
        const n = this;
        n.barDom.style.visibility = "visible";
        $(n.barDom).fadeIn(300, function () {
          promise(function (resolve) {
            resolve();
          });
        });
      },
      close: function (promise) {
        const n = this;
        $(n.barDom).fadeOut(300, function () {
          $(n.barDom).remove();
          promise(function (resolve) {
            resolve();
          });
        });
      },
    },
  }).show();
}

function fade2nd(){
  document.querySelectorAll("#cou-tabbody .cou-group .item").forEach((e)=>{e.onmouseenter = ()=>{
    try {
        document.querySelector("#cou-tabbody .cou-items #removefade2nd .item.hide").click();
    } catch (error) {}
    document.querySelector("#removefade2nd").innerHTML = ""
  }   })
}


$("#step3Previous").on("click", function (event) {
  event.stopPropagation();
  window.accolade.locations = [];
  window.accolade.items = [];

  $("#table-body").empty();
  $(".cou-items").find("input[type=checkbox]").prop("checked", false);
  $(".cou-items").find("label").removeClass("checked");
  $(".cou-selected").empty();

  fade2nd();
  _clearAllCartItems();
  window.scrollTo( 0 , 0 );
});
